export const selectToken = state => state.user.token;

export const selectUser = state => state.user;